import React from "react";
import PropTypes from "prop-types";

import Information from "./Information";
import RequestNoActive from "./RequestNoActive";
import RequestProcessed from "./RequestProcessed";

const NotAccepted = ({ request, userHoursThisWeek, subHoursThisWeek, shiftHours }) => (
  <table className="table table-clean table-white shadowDepth1">
    <tbody>
      <Information
        request={request}
        shiftHours={shiftHours}
        userHoursThisWeek={userHoursThisWeek}
      />

      {!request.active ? (
        <RequestNoActive
          request={request}
          shiftHours={shiftHours}
          subHoursThisWeek={subHoursThisWeek}
        />
      ) : null}

      {!request.active && request.processed ? (
        <RequestProcessed request={request} />
      ) : null}
    </tbody>
  </table>
);

NotAccepted.propTypes = {
  request: PropTypes.object,
  shifts: PropTypes.array,
  userHoursThisWeek: PropTypes.number,
  subHoursThisWeek: PropTypes.number,
  shiftHours: PropTypes.number
};

NotAccepted.defaultProps = {
  shiftHours: 0,
  userHoursThisWeek: 0
};

export default NotAccepted;
